import React, { Component } from "react";
import { Route } from "react-router-dom";
import { connect } from 'react-redux';
import asyncComponent from "../../helpers/AsyncFunc";
import customRoutes from "../../customApp/router";
import options from "../../customApp/sidebar";

const routes = [
  {
    path: "",
    component: asyncComponent(() => import("../dashboard"))
  },
  {
    path: "blankPage",
    component: asyncComponent(() => import("../blankPage"))
  },
  ...customRoutes
];

class AppRouter extends Component {
  render() {
    const { url, style, admin, userPermissions } = this.props;
    // Flattening the options array
    const flatOptions = options.reduce((flatOptions,
      { children, ...other }) => children ? flatOptions.concat(children) : flatOptions.concat([{...other}]),
      []);
    let routePermissions = {};
    flatOptions.forEach((option) => routePermissions = {
      ...routePermissions,
      [option.key]: option.permitted,
    })
    let routePermissionKeys = Object.keys(routePermissions);
    return (
      <div style={style}>
        {routes.map(singleRoute => {
          const { path, exact, ...otherProps } = singleRoute;
          // Fetch the permission set for each path
          const delimiterIndex = path.indexOf("/:");
            const trimmedPath = path.substring(0, delimiterIndex >=0 ? delimiterIndex : path.length);
            let permission = routePermissions[trimmedPath];
            // If permission is not found prune the path and search for a match
            if (!permission) {
              const [key] = routePermissionKeys.filter(
                routePermissionKey => routePermissionKey.toLowerCase() === trimmedPath.substring(0, routePermissionKey.length).toLowerCase()
              );
              permission = routePermissions[key];
            }
            // If no permission is found then it is a free path and is granted access to all
            const route =
              <Route
                exact={exact === false ? false : true}
                key={singleRoute.path}
                path={`${url}/${singleRoute.path}`}
                {...otherProps}
              />
              ;
            if (permission) {
              if (admin || permission.some(r => userPermissions.includes(r))) {
                return route;
              }
            } else {
              return route;
            }
        })}
      </div>
    );
  }
}

export default AppRouter;
